<template>
  <nav role="navigation" id="navbar" class="navbar bg-dark navbar-expand-lg navbar-dark navbar-custom sticky-top">
    <div class="container-fluid navbar-custom">
      <span class="logo navbar-brand navbar-custom"><router-link :to="'/'" class="navbar-brand navbar-custom"><img src="~/@/assets/observeit-logo.png" width="145px" class="logo" /></router-link><span class="logo-text">Developers</span></span>
      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav ml-auto flex-nowrap">
          <li class="nav-item dropdown">
            <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown1" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                Resources
            </a>
            <div class="dropdown-menu" aria-labelledby="navbarDropdown1">
              <router-link v-for="(page,index) in pages" :key="page.sys.id + '_' + index" class="dropdown-item" :to="'/article/' + page.sys.id">{{ page.fields.title }}</router-link>
            </div>
          </li>
          <li class="nav-item dropdown">
            <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown2" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              REST API Reference
              </a>
              <div class="dropdown-menu" aria-labelledby="navbarDropdown2">
                <router-link v-for="spec in specs" :key="spec.name" class="dropdown-item" :to="{path: '/rest', query: {url: spec.uri}}" >{{ spec.description }}</router-link>
              </div>
          </li>
          <li class="nav-item dropdown">
            <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown3" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              Community
            </a>
            <div class="dropdown-menu" aria-labelledby="navbarDropdown3">
              <a class="dropdown-item" target="_blank" href="https://goo.gl/forms/PLe1cra1VVu7LZfI2">Join Now</a>
              <a class="dropdown-item" href="slack://channel?id=GGT0CA9GB&team=T7R89HX3Q">Open in Slack</a>
            </div>
          </li>
          <li class="nav-item">
            <Searcher/>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>
<script>
 import Searcher from '@/components/Searcher.vue'
 import 'whatwg-fetch';
 
 export default {
   name: 'PortalHeader',
   components: {
     Searcher
   },
   data() {
     return {
       pages: [],
       specs: []
     }
   },
   methods: {
     sortArticles(arr) {
       // Alphabetize the list by title
       return arr.sort((a, b) => { return (a.fields.title > b.fields.title) ?  1 : ((a.fields.title < b.fields.title) ? -1: 0); });
     },
     getArticles() {
       const query = {
         skip: 0,
         limit: 10,
         content_type: "guide",
         include: 0
       };
       this.$contentful
           .getEntries(query)
           .then((res) => {
             console.log("got some articles")
             console.log(res.items)
             this.pages = this.sortArticles(res.items)
           })
           .catch((error) => {
             console.error( 'ERROR: ' + error );
           })
     },
     getAPIs() {
       fetch("https://api.preview1.try-observeit.com/v2/apps/portal/apis.json",
             {
               mode: 'cors'
             })
         .then(data=> {
           if (!data.ok) {
             throw Error(response.statusText);
           }
           return data.json()
         })
         .then(res=> {
           res.data.forEach(item=>{
             console.log(item)
             if(!item.toggle) {
               item.uri = "https://api.preview1.try-observeit.com" + item.uri + "/_resources";
               this.specs.push(item);
             }
           });
           console.log(JSON.stringify(res))
         })
         .catch(error=> {
           alert(error)
         })
     },
     fixAPIURL(value) {
       var index = value.indexOf("/v2/apps/portal");
       if (index != -1) {
         console.log("NEW VALUE: https://api.preview1.try-observeit.com" + value.substring(index))
         return "https://api.preview1.try-observeit.com" + value.substring(index);
       }
       else {
         console.log("JUST USE VALUE AS IS: " + value)
         return value;
       }
     }
   },
   created() {
     this.getArticles();
     this.getAPIs();
   }
 }
</script>

<style>
 .container-fluid {
     margin-left: 10%;
     margin-right: 10%;
     padding: 0;
 }

 @media all and (max-width: 800px) {
     .container-fluid {
         margin-left: 2%;
         margin-right: 2%;
     }
 }
 
 nav.navbar.navbar-custom {
     background-color: #002330;
 }
 /* change the brand and text color */
 /* change the link color */
 
 .navbar-custom .nav-item .nav-link  {
     font-family: 'Open Sans', sans-serif;
     font-weight: 600;
     font-size: 16px;
     font-style: normal;
     font-stretch: normal;
     line-height: normal;
     letter-spacing: normal;
     color: white;
 }
 /* change the brand color */
 .navbar-default .navbar-brand,
 .navbar-custom .navbar-brand {
     vertical-align: bottom;
     margin-right: 4px;
     color: rgba(255,255,255) !important;
 }
 /* change the color of active or hovered links */
 .navbar-custom .nav-item.active .nav-link,
 .navbar-custom .nav-item:hover .nav-link {
     color: #00cdff;
 }

 .logo {
     font-family: 'Open Sans', sans-serif;
     font-weight: 600;
     font-size: 15px;
     font-style: normal;
     font-stretch: normal;
     line-height: normal;
     letter-spacing: normal;
     color: white;
 }

 .logo-text{
     position: relative;
     bottom: 2px;
 }

 /* bootstrap override for search button color*/
 .btn-outline-success {
     color: #f1582b;
     border: 1px solid #f1582b;
     box-shadow: none !important;
 }
 .btn-outline-success:hover, .btn-outline-success:active, .btn-outline-success:visited {
     background-color:  #f1582b !important;
     border: 1px solid #f1582b !important;
     box-shadow: 0 0 0 0.2rem   !important;
 }

 img.logo {
     padding-right: 6px;
     margin-right: 5px;
     border-right: 1px solid white;
 }

 .navbar-toggler {
     color: white;
 }

</style>
